<template>
    <div>
        <header class="header">
            <div class="step_list">
                <div class="step_item" :class="current == item.id ? 'active' : ''" :key="item.id" v-for="item in stepList" @click="changeStep(item)">
                    <span class="step_num">{{item.num}}</span>{{item.name}}
                </div>
            </div>
        </header>
      <section class="block imageText video-block" v-if="flowVideoSrc">
        <div class="title">视频说明</div>
        <div class="video-box">
          <video :src="flowVideoSrc" width=350 height=240 controls=controls class="video"></video>
        </div>
      </section>
        <section class="block imageText">
            <div class="title">图文说明</div>
            <div class="imageText_list">
                <div class="imageText_item" v-for="(item,index) in flowImagesList" :key="index" @click="open(item)">
                    <img class="imageText_img" :src="item.image" alt="">
                    <div class="imageText_text">{{item.describe}}</div>
                </div>
            </div>
        </section>

      <el-dialog
        :visible.sync="dialogVisible"
        width="85%"
        top="2vh"
        :before-close="handleClose">
        <div class="flow-large">
          <img class="imageText_img" :src="flowLargeImage" alt="">
        </div>
<!--        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogVisible = false">关闭</el-button>
        </span> -->
      </el-dialog>

    </div>
</template>
<script>
    import {getFlow} from "../request/api";
    import {Toast} from "mint-ui";

    export default {
        name: '',
        components: {
        },
        data () {
            return {
              current:0,
              stepList:[
                  {
                      name: "店铺设置",
                      num: "1",
                      id: 0,
                      active: "active"
                  },{
                      name: "添加商品",
                      num: "2",
                      id: 1,
                      active: ""
                  },{
                      name: "订单操作",
                      num: "3",
                      id: 2,
                      active: ""
                  },{
                      name: "提现",
                      num: "4",
                      id: 3,
                      active: ""
                  },
              ],
              flowList:[],           //定义操作流程的数据
              flowImagesList:[],    //定义操作流程的图片
              flowVideoSrc:"",         //定义操作流程的视频
              dialogVisible:false,
              flowLargeImage:"",   //定义放大的图片
            }
        },
        created(){
          document.title = "操作流程";
        },
        mounted() {
          this.getFlowData();
          // 修改网页的标题
          document.title = "操作流程";
        },
        methods:{
            changeStep(data){
                  this.flowVideoSrc = "";   //清空掉视频
                  this.current = data.id;
                  this.flowList.forEach((item,index)=>{
                    if(index === data.id){
                      this.flowImagesList = item.image_data;
                      this.flowVideoSrc = item.video_path;
                    }
                  })
              let video = document.querySelector('video');
              console.log(video,'获取到了什么');
            },

            getFlowData(){
              getFlow().then((res)=>{
                do{
                  if(res.code !==0){
                    Toast({
                      message: res.msg,
                      duration: 2000,
                    });
                    break
                  }
                  this.flowList = res.data.list;
                  if(this.current ===0 ){
                    this.flowImagesList = res.data.list[0].image_data;
                    this.flowVideoSrc = res.data.list[0].video_path;
                  }
                }while (false)
              }).catch(()=>{

              })
            },

            open(item) {
              this.flowLargeImage = item.image;
              this.dialogVisible = true;
            },
            handleClose(){
              this.dialogVisible = false;
            }
        }

    }
</script>
<style lang="less">
    .header{
        .step_list{
            margin-top: 10px;
            display: flex;
            justify-content: space-around;
            font-size: 2.4rem;
            color: #333333;
            border-bottom: 1px solid #E5E5E5;
            padding-bottom: 3.3rem;
            .active{
                color: #0E84EA;
                position: relative;
                .step_num{
                    color: #0E84EA;
                    border: 1px solid #0E84EA;
                }
            }
            .active::after{
                content: "";
                background-color: #0E84EA;
                bottom: -1.5rem;
                left: 4rem;
                position: absolute;
                width: 5.5rem;
                height: 0.4rem;
            }
            .active:nth-of-type(4).active::after{
                content: "";
                background-color: #0E84EA;
                bottom: -1.5rem;
                left: 1.8rem;
                position: absolute;
                width: 5.5rem;
                height: 0.4rem;
            }
            .step_item{
                display: flex;
                align-items: center;
                height: 26px;
                line-height: 26px;
                font-size: 18px;
                font-weight: 600;
            }
            .step_num{
                border: 1px solid #333333;
                border-radius: 50%;
                width: 2.4rem;
                height: 2.4rem;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 2.4rem;
            }
        }
    }
    .block{
        width: 100%;
        display: flex;
        flex-direction: column;
        padding: 20px;
        box-sizing: border-box;
        .title{
            font-size: 3.5rem;
            margin-bottom: 3.7rem;
            font-weight: 600;
        }
    }

    .imageText_list{
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        flex-wrap: wrap;
        .imageText_item{
            width: 32%;
            margin-bottom: 2rem;
        }
        .imageText_img{
            width: 100%;
            height: 220px;
        }
        .imageText_text{
            font-size: 12px;
            color: #999999;
            margin-top: 1.4rem;
            line-height: 18px;
        }
    }
    .imageText_list::after{
      width: 18.4rem;
      content: "";
    }

    .video-block{
      width: 100%;
      .video-box{
        width: 100%;
        display: flex;
        justify-content: center;
        align-content: center;
      }
    }

    .flow-large{
      width: 100%;
      .imageText_img{
        width: 100%;
      }
    }

</style>



// WEBPACK FOOTER //
// src/page/tutorial.vue